<template>
  <div>
    <div class="mt-4" v-for="category in categories">
      <div class="p-2 rounded" :style="borderColor()">
        <Category :mode="mode" :category="category"/>
        <categories v-if="mode !=='trash'  " :mode="mode" :categories="category.children"/>
      </div>
    </div>
  </div>
</template>
<script>
import Category from "./Category";

export default {
  name: "categories",
  components: {Category},
  props: {
    categories: {},
    mode: {
      default: 'categories'
    }
  },
  methods: {
    borderColor() {
      let border = 'border:1px solid ';
      return border + `rgb(${this.randomRGBNumber()})`
    },
    randomRGBNumber() {
      let o = Math.round, r = Math.random, s = 255;
      return ` ${o(r() * s)} , ${o(r() * s)},${o(r() * s)}`
    }
  }
};
</script>

<style scoped>
</style>
